// src/features/insurancePlan/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import PlanGroupPage from './pages/planGroup/PlanGroupPage';
import ServiceTypePage from './pages/serviceType/ServiceTypePage';
import PlanGroupForm from './pages/planGroup/PlanGroupForm';
import ServiceTypeForm from './pages/serviceType/ServiceTypeForm';
import PlanSetup from './pages/SetupPlan/SetupPlan';
import SetupPlanNewEdit from './pages/SetupPlan/SetupPlanForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const insurancePlanRoute = createRoute({
  getParentRoute: () => rootRoute,
    path: '/insurance-plan',
});

export const insurancePlanGroupRoute = createRoute({
  getParentRoute: () => insurancePlanRoute,
    path: '/plan-group',
    component: PlanGroupPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.SEARCH_PLANGROUP || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const insurancePlanGroupFormRoute = createRoute({
    getParentRoute: () => insurancePlanRoute,
    path: '/plan-group/form',
    component: PlanGroupForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.SAVE_PLANGROUP || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const insurancePlanServiceTypeRoute = createRoute({
  getParentRoute: () => insurancePlanRoute,
    path: '/service-type',
    component: ServiceTypePage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.SEARCH_SERVICETYPE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const insuranceServiceTypeFormRoute = createRoute({
    getParentRoute: () => insurancePlanRoute,
    path: '/service-type/form',
    component: ServiceTypeForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.SAVE_SERVICETYPE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const planSetupRoute = createRoute({
  getParentRoute: () => insurancePlanRoute,
    path: '/setup-plan',
    component: PlanSetup,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.GET_PLAN || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const planSetupFormRoute = createRoute({
    getParentRoute: () => insurancePlanRoute,
    path: '/setup-plan/form',
    component: SetupPlanNewEdit,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.INSURANCEPLAN.SAVE_PLAN || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const insurancePlanRoutes = [
    insurancePlanRoute,
    insurancePlanGroupRoute,
    insurancePlanGroupFormRoute,
    insurancePlanServiceTypeRoute,
    insuranceServiceTypeFormRoute,
    planSetupRoute,
    planSetupFormRoute
];